import Ajax from '../common/ajax'
import ApiBase from './api-base'

export default {
  ...ApiBase,
  model: 'trade',
  callBack (id) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/callBack/${id}`, {}, { showLoading: false })
  },
  sign (data) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/sign`, data)
  },
  create (data) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/createOrder`, data)
  },
  refundExam (data) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/refund`, data)
  },
  getAllAmount (data) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/calculateAmount`, data)
  }
}
